/* ezspa-reviews.js — de horizontale rij met beoordelingen.

   Twee stukken, allebei overgenomen uit het thema van Earthle:
   alleen de pijlen naast de kop, uit earthle.js. Het slepen met de muis zit
   in ezspa-flow.js, dat op elke pagina laadt; anders werd het twee keer
   aangehaakt.
*/

/* ---------------- beoordelingen: pijlen bij de horizontale rij ------------- */
(function(){
  var rails = Array.prototype.slice.call(document.querySelectorAll('[data-rev-rail]'));
  rails.forEach(function(rail){
    var vak = rail.closest('section');
    if(!vak) return;
    var knoppen = Array.prototype.slice.call(vak.querySelectorAll('[data-rev-schuif]'));

    function stap(){
      var kaart = rail.querySelector('.rev');
      return kaart ? kaart.getBoundingClientRect().width + 16 : rail.clientWidth * 0.8;
    }
    function bij(){
      var meer = rail.scrollWidth - rail.clientWidth - 4;
      knoppen.forEach(function(k){
        var kant = +k.getAttribute('data-rev-schuif');
        k.disabled = kant < 0 ? rail.scrollLeft <= 4 : rail.scrollLeft >= meer;
      });
      vak.classList.toggle('kan-schuiven', meer > 0);
    }
    knoppen.forEach(function(k){
      k.addEventListener('click', function(){
        rail.scrollBy({ left: stap() * (+k.getAttribute('data-rev-schuif')), behavior:'smooth' });
      });
    });
    rail.addEventListener('scroll', bij, {passive:true});
    addEventListener('resize', bij);
    bij();
  });
})();
